import React from "react";
import {observer, inject} from "mobx-react";
import debounce from '@utils/debounce';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

//@inject("store")
@observer
export class QuantityEdit extends React.Component {
    // Make sure to set "Key" to reset internal state 
    constructor(props) {
        super(props);

        this.handleQuantityUpdate = this.handleQuantityUpdate.bind(this);
        this.debounceCommit = debounce(this.debounceCommit.bind(this), 1000);
        this.commitQuantity = this.commitQuantity.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.addQuantity = this.addQuantity.bind(this);
        const orderStore = this.props.orderStore;
        const activeOrder = orderStore.activeOrder;

        const orderLines = activeOrder && activeOrder.OrderLinesBySku(this.props.sku, this.props.variantSku);
        const quantity = orderLines && orderLines.length > 0 ? orderLines[0].Quantity : 0;


        this.state = {
            pendingCommit:false,
            updating: false,
            sku: this.props.sku,
            variantSku: this.props.variantSku,
            increments: this.props.increments || 1,
            productUrl: this.props.productUrl,
            quantity: quantity,
            //baseQuantity: quantity,
            //useTextAddButton: this.props.useTextAddButton || false,
            timeStamp: activeOrder && activeOrder.TimeStamp || 0
        }
        
        
    }

    handleQuantityUpdate(event) {
        var amount = parseInt(event.target.value);
        
        if (isNaN(amount)) {
            amount = 0;
        }
        this.setState({
            quantity: amount, 
            //baseQuantity: amount, 
            pendingCommit: true
        });
    }

    addQuantity(e, addAmount) {
        e.stopPropagation();
        e.preventDefault();
        //Convert.ToInt32(Math.Ceiling((decimal) toRound / packSize) * packSize);
        
         
        const newQuantity = Math.ceil((this.state.quantity+addAmount) / this.state.increments) * this.state.increments
                
        
        this.setState({
            quantity: newQuantity, 
            //baseQuantity: newQuantity, 
            pendingCommit:true},
            () => this.debounceCommit(newQuantity));
        
    }

    debounceCommit(quantity) {
        this.commitQuantity(quantity);
    }

    commitQuantity(quantity) {
        const orderStore = this.props.orderStore;

        // if (isNaN(parseInt(this.state.quantity))) {
        //     this.setState({quantity: 0});
        //     return;
        // }

        //const newQuantity = Math.ceil((this.state.quantity) / this.state.increments) * this.state.increments;


        if (isNaN(parseInt(quantity))) {
            this.setState({quantity: 0});
            return;
        }

        const newQuantity = Math.ceil((quantity) / this.state.increments) * this.state.increments;


        const changes =
            [
                {
                    OrderLineId: -1,
                    Sku: this.state.sku,
                    VariantSku: this.state.variantSku,
                    OriginalQuantity: newQuantity,
                    ProductUrl: this.state.productUrl
                }
            ];
        
        orderStore.updateQuantities(changes).then(
            res => {
                this.setState({pendingCommit: false});
            }
        )
        
        //this.setState({pendingCommit: false});
    }
        
    

    componentDidUpdate(prevProps, prevState) {
        ///console.log("componentDidUpdate", this.props.quantity);
        // if (this.state.updating && this.state.quantity !== this.props.quantity) {
        //     console.log("newQuantity:", this.props.quantity);
        //     //this.setState({ quantity: this.props.quantity, orderQuantity: this.props.quantity, updating: false });
        // }

        // const orderlines = this.props.store.order.activeOrder && this.props.store.order.activeOrder.OrderLinesBySku(this.props.sku, this.props.variantSku);
        // const quantity = orderlines && orderlines.length > 0 ? orderlines[0].Quantity : 0;
        //
        // if (this.state.quantity !== quantity) {
        //     //console.log("componentDidupdate: new quantity:", this.state.baseQuantity, this.props.quantity, orderlines);
        //     this.setState({quantity: this.props.quantity, baseQuantity: this.props.quantity});
        // }
    }

    componentWillReact() {
        const orderStore = this.props.orderStore;
        const activeOrder = orderStore.activeOrder;
        
        if(!this.state.pendingCommit && activeOrder && activeOrder.TimeStamp > this.state.timeStamp)
        {
            const orderlines = activeOrder && activeOrder.OrderLinesBySku(this.props.sku, this.props.variantSku);
            const quantity = orderlines && orderlines.length > 0 ? orderlines[0].Quantity : 0;
            this.setState({quantity: quantity, baseQuantity: quantity,  timeStamp: activeOrder.TimeStamp});
        }

        // if(this.state.quantity > 0 ) {
        //     console.log("componentWillReact", this.state.quantity, quantity, this.state.pendingCommit);
        // }
        //
        // if (
        //     //!this.state.pendingCommit && 
        //     this.state.baseQuantity !== quantity) {
        //     console.log("componentWillReact: new quantity:", this.state.baseQuantity, quantity, orderlines);
        //     this.setState({quantity: quantity, baseQuantity: quantity});
        // }
        
        

    //    console.log("componentWillReact ", this.state.orderQuantity, quantity, this.state.updating);

    //    //if (this.state.updating) {
    //    //    this.setState({ quantity: quantity, orderQuantity: quantity });
    //    //}
    //    //else if (quantity !== this.state.orderQuantity ) {
    //    //    this.setState({ quantity: quantity, orderQuantity: quantity });
    //    //    this.setState({ updating: false });
    //    //}
    }

    onKeyDown(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            const newQuantity = Math.ceil((this.state.quantity) / this.state.increments) * this.state.increments;    

            this.commitQuantity(newQuantity);
        }
    }

    render() {
        // if (!this.props.store.order.activeOrder) {
        //     return null;
        // }
        //const orderlines = this.props.store.order.activeOrder.ProductList.map(list => list.OrderLines.filter(x => x.Sku === this.props.sku && x.VariantSku === this.props.variantSku))
        //    .reduce((a, b) => a.concat(b), []);

        const orderlines = this.props.orderStore.activeOrder && this.props.orderStore.activeOrder.OrderLinesBySku(this.props.sku, this.props.variantSku);
        const quantity = orderlines && orderlines.length > 0 ? orderlines[0].Quantity : 0;
        
        const readOnly = this.props.disabled || (this.props.orderStore.activeOrder && this.props.orderStore.activeOrder.Readonly);

        return (<div className="quantity-edit-container">
            {(this.state.quantity > 0 || this.state.pendingCommit) &&
                [<button key="quantity-edit-remove" disabled={this.state.quantity < 1 || this.state.updating || readOnly} className="quantity-edit-remove product-button-basket small remove-quantity" type="button" onClick={e => this.addQuantity(e, -1 * this.state.increments)}>
                    <FontAwesomeIcon
                        icon={["fas", "minus"]} className=""/></button>,
                <input key="quantity-edit-input" className="form-control quantity-edit-input" 
                       disabled={this.state.updating || readOnly}
                type="text" pattern="\d*" inputMode="numeric" placeholder="Quantity"
                value={this.state.quantity}
                onClick={e=> {
                    e.preventDefault();
                    e.stopPropagation();
                }}
                onFocus={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.target.select();
                }}
                onChange={e => this.handleQuantityUpdate(e)}
                onKeyDown={this.onKeyDown}
                onBlur={e=> {
                    e.preventDefault();
                    e.stopPropagation();
                    this.commitQuantity(this.state.quantity);}
                }

                />,
                <button key="quantity-edit-add" disabled={this.state.updating || readOnly} className="quantity-edit-add product-button-basket small add-quantity" type="button" onClick={e => this.addQuantity(e,1)}><FontAwesomeIcon icon={["fas", "plus"]} className=""/></button>
                ]
            }
            {!(this.state.quantity > 0 || this.state.pendingCommit) && 
                (this.props.textAddButton 
                    ? <button className="quantity-edit-add-to-basket" disabled={this.state.updating || readOnly} type="button" onClick={e => this.addQuantity(e,1)}>{this.props.textAddButton}</button>
                    : <button key="quantity-edit-add" disabled={this.state.updating || readOnly} className="quantity-edit-add product-button-basket small add-quantity" type="button" onClick={e => this.addQuantity(e,1)}><FontAwesomeIcon icon={["fas", "plus"]} className=""/></button>)
            }
        </div>);
    }

}